/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var levARSlideshow = document.querySelectorAll('.Product__Gallery .Product__Slideshow')[0],
    levARSlideshowNav = document.querySelectorAll('.Product__Gallery .Product__SlideshowNav')[0],
    levARPlayer = document.getElementById('levar-player'),
    levARPhotoBox = document.getElementById('levar_photo_box'),
    levARProductWrapper = document.querySelectorAll('section.Product[data-section-id="product-template"]')[0],
    levARButtons = document.getElementById('levar_buttons_wrapper'),
    levARButtonsInit = (levARButtons.offsetTop + 60),
    levARButtonsEnd = (levARProductWrapper.offsetTop + levARProductWrapper.offsetHeight - 190),
    levARProductSlideshowSlides = document.querySelectorAll('.Product__Gallery .Product__Slideshow .Product__SlideItem'),
    levARFirstImg = levARProductSlideshowSlides[0];

function levARStickyHelper() {
  levARPlayer.addEventListener('click', function() {
    // var levARViewer = document.getElementById('levar_player_iframe');
    // if (levARViewer == null) {
    //   if(levARSlideshowNav != null) levARSlideshowNav.classList.add('levar-active');
    //   if(levARPhotoBox != null) levARPhotoBox.classList.add('levar-active');
    //   if(levARButtons != null) levARButtons.classList.add('levar-active');
    // }
    levARProductWrapper.scrollIntoView({ behavior: 'smooth', block: 'start'});
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
  
  // document.getElementById('levar_photo_box').addEventListener('click', function(e) {
  //   if(e.target && e.target.id== 'levar_iframe_close'){
  //     if(levARSlideshowNav != null) levARSlideshowNav.classList.remove('levar-active');
  //     if(levARPhotoBox != null) levARPhotoBox.classList.remove('levar-active');
  //     if(levARButtons != null) levARButtons.classList.remove('levar-active');
  //   }
  // });
}

function levARMatchHeight() {
  var levARSlideshowHeight = levARSlideshow.offsetHeight+40,
      levARFirstImgHeight = levARFirstImg.offsetHeight*(0.95);
  if (window.matchMedia("(max-width: 992px)").matches) {
    levARButtons.style.top = levARSlideshowHeight+'px';
  } else {
    levARButtons.style.top = levARFirstImgHeight+'px';
    levARButtonsInit = (levARButtons.offsetTop + 60);
  }
}  
  
let resizeObserver = new ResizeObserver(() => {
  levARMatchHeight();
});

levARStickyHelper();
resizeObserver.observe(levARSlideshow);

window.onscroll = function (e) {
  var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop,
      levARButtonsStart = levARButtonsInit,
      levARButtonsStop = levARButtonsEnd;
  
  if (window.matchMedia("(max-width: 1144px)").matches) {
    levARButtonsStop = levARButtonsEnd + 60;
  }
 
  if (scrollTop >= levARButtonsStart && scrollTop <= levARButtonsStop) {
    levARButtons.classList.remove('levar-unstick');
    levARButtons.classList.add('levar-stick');
  } else if (scrollTop > levARButtonsStop) {
    levARButtons.classList.remove('levar-stick');
    levARButtons.classList.add('levar-unstick');
  } else {
    levARButtons.classList.remove('levar-stick');
    levARButtons.classList.remove('levar-unstick');
  }
}